import { useState } from 'react';
import { programs } from '../data/programs';
import ProgramAccordion from './ProgramAccordion';
import EsyohWidget1034984 from './EsyohWidget1034984';
import EsyohWidget874239 from './EsyohWidget874239';

function Directory() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="directory section" id="programs">
      <EsyohWidget1034984 />
      <EsyohWidget874239 />
      <div className="section-heading align-left">
        <p className="eyebrow">Compare your options</p>
        <h2>Best HVAC Schools in Las Vegas</h2>
        <p>
          Las Vegas HVAC programs can differ significantly in schedule, tuition,
          lab access, credential level, hands-on training, and career support.
          Use these profiles to narrow your search, then contact each provider
          to verify current enrollment dates, total costs, admission requirements,
          and available classes.
        </p>
      </div>
      <div className="accordion-stack">
        {programs.map((program, index) => (
          <ProgramAccordion
            key={program.name}
            program={program}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
        <p>
          Strong programs typically combine classroom instruction with mechanical
          labs. Students may study electrical theory, refrigeration cycles, air
          distribution, motors, controls, brazing, safe tool use, system
          diagnostics, preventive maintenance, and troubleshooting for residential
          and commercial equipment throughout the Las Vegas market.
        </p>
      </div>
    </section>
  );
}

export default Directory;